import { Component } from '@angular/core';

@Component({
  selector: 't-hamburger-menu-icon',
  standalone: true,
  imports: [],
  templateUrl: './hamburger-menu-icon.component.html',
  styleUrl: './hamburger-menu-icon.component.css',
})
export class HamburgerMenuIconComponent {}
